import React from 'react';
import { Field } from '../index';
import { CreatableOptionsProvider } from '../../../components/v2/Form/Adapter/SelectCreatableAdapter';
import http from '../../../utils/http';

type Props = {
  field: Field;
};

const SelectCreatableOptionsProvider = (
  props: React.PropsWithChildren<{ name: string }>,
) => {
  const { name } = props;

  return (
    <CreatableOptionsProvider
      {...props}
      onCreate={(option) => {
        void http.post(`/api/intelligence/choice/${name}`, {
          value: option.label,
        });
      }}
      onUpdate={(prev, current) => {
        void http.put(`/api/intelligence/choice/${name}/${prev.value}`, {
          value: current.label,
        });
      }}
      onRemove={(option) => {
        void http.delete(`/api/intelligence/choice/${name}/${option.value}`);
      }}
    />
  );
};

const FieldProviders = ({
  field,
  children,
}: React.PropsWithChildren<Props>) => {
  return (
    <SelectCreatableOptionsProvider name={field.name}>
      {children}
    </SelectCreatableOptionsProvider>
  );
};

export default FieldProviders;
